import { observer } from "mobx-react-lite";
import React, { FC, FormEvent, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Context } from "..";

const LoginForm: FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const { store } = useContext(Context);

  const onSubmitHandler = async (evt: FormEvent) => {
    evt.preventDefault();
    const response = await store.login(email, password);
    if (response) {
      const formBlock = document.querySelector(".form__block");
      const formSubmit = document.querySelector(".form__submit");
      const formInputs = formBlock?.querySelectorAll(".form__input");
      formInputs?.forEach((input) => {
        input.classList.add("invalid");
      })
      const errorBlock = formBlock?.querySelector(".form__error");
      formBlock?.classList.add("shake");
      setTimeout(() => {
        formBlock?.classList.remove("shake");
      }, 500);
      if (errorBlock) {
        return;
      }
      const error = document.createElement("div");
      error.classList.add("form__error");
      error.textContent = response;
      formBlock?.insertBefore(error, formSubmit);
    }
  }

  return (
    <div className="form">
      <form className="form__block" onSubmit={onSubmitHandler}>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-email">Ваш email</label>
          <input
            className="form__input"
            onChange={(e) => {
              setEmail(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
            }}
            value={email}
            inputMode="email"
            type="email"
            placeholder="Ваш email"
            id="form-email"
            required
          />
        </fieldset>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-password">Ваш пароль</label>
          <input
            className="form__input"
            onChange={(e) => {
              setPassword(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
            }}
            value={password}
            type="password"
            placeholder="Ваш пароль"
            id="form-password"
            required
            autoComplete="on"
          />
        </fieldset>
        <button className="form__submit" type="submit">
          Увійти
        </button>
      </form>
      <Link className="form__link" to="registration">Зареєструватись</Link>
      <Link className="form__link" to="restore">Відновити пароль</Link>
    </div>
  );
};

export default observer(LoginForm);
